import { render, staticRenderFns } from "./ConfigAlertStomp.vue?vue&type=template&id=45dd2ae4&"
import script from "./ConfigAlertStomp.vue?vue&type=script&lang=js&"
export * from "./ConfigAlertStomp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports